import { MagnifyingGlassIcon, NoteIcon, PenNibIcon } from "@phosphor-icons/react";

import { PageDataPlaceholder } from "@/shared/components/ui/PageDataPlaceholder";

interface NotesEmptyPlaceholdersProps {
  hasNotes: boolean;
  filteredNotesLength: number;
  hasSearchOrFilters: boolean;
  deviceType: "desktop" | "mobile";
}

export function NotesEmptyPlaceholders({
  hasNotes,
  filteredNotesLength,
  hasSearchOrFilters,
  deviceType,
}: NotesEmptyPlaceholdersProps) {
  // Show "No notes found" when search/filters are active but no notes match
  if (hasSearchOrFilters && filteredNotesLength === 0) {
    return (
      <PageDataPlaceholder
        title="No notes found"
        description="Try searching with different keywords"
        icon={<MagnifyingGlassIcon />}
      />
    );
  }

  // Show "No notes yet!" when there are truly no notes in the system
  if (!hasNotes) {
    return (
      <PageDataPlaceholder
        description={
          <span>
            {deviceType === "desktop" ? "Press on" : "Tap"} <PenNibIcon className="text-primary mx-1 inline-block" /> to
            create one!
          </span>
        }
        icon={<NoteIcon />}
        title="No notes yet!"
      />
    );
  }

  return null;
}
